import { Skeleton } from '../../../../Skeleton'
import {
  REQUEST_PROFILE_TAB_ACTIVITIES_SKELETON_TABLE_ROW_TITLE_WIDTHS,
  REQUEST_PROFILE_TAB_ACTIVITIES_SKELETON_TABLE_ROWS_COUNT,
} from '../RequestProfileTabActivitiesSkeleton.constants'

import * as styles from '../RequestProfileTabActivitiesSkeleton.module.css'

function RequestProfileTabActivitiesSkeletonPhaseTable() {
  return (
    <div className={styles.phaseContent}>
      <div className={styles.tableHeaderRow}>
        <Skeleton className={styles.tableHeaderStatusSkeleton} />
        <Skeleton className={styles.tableHeaderTitleSkeleton} />
      </div>
      {Array.from({
        length: REQUEST_PROFILE_TAB_ACTIVITIES_SKELETON_TABLE_ROWS_COUNT,
      }).map((_, index) => (
        <div className={styles.tableRow} key={index}>
          <Skeleton className={styles.tableRowStatusSkeleton} />
          <Skeleton
            className={styles.tableRowTitleSkeleton}
            style={{
              width:
                REQUEST_PROFILE_TAB_ACTIVITIES_SKELETON_TABLE_ROW_TITLE_WIDTHS[
                  index
                ],
            }}
          />
        </div>
      ))}
      <div className={styles.tableFooter}>
        <Skeleton className={styles.addActivitySkeleton} />
      </div>
    </div>
  )
}

export default RequestProfileTabActivitiesSkeletonPhaseTable
